import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  close1s6qtnweux4fu as close,
  ObjectPool3iks1t8z0qq3m as ObjectPool,
} from './Pool.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultPoolClass;
function DefaultPool() {
  if (DefaultPoolClass === VOID) {
    class $ {
      constructor(capacity) {
        this.j4m_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.j4m_1;
        tmp.k4m_1 = Array(size);
        this.l4m_1 = 0;
      }
      m4m(instance) {
      }
      n4m(instance) {
        return instance;
      }
      o4m(instance) {
      }
      p4m() {
        if (this.l4m_1 === 0)
          return this.i4m();
        this.l4m_1 = this.l4m_1 - 1 | 0;
        var idx = this.l4m_1;
        var tmp = this.k4m_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.k4m_1[idx] = null;
        return this.n4m(instance);
      }
      q4m(instance) {
        this.o4m(instance);
        if (this.l4m_1 === this.j4m_1) {
          this.m4m(instance);
        } else {
          var _unary__edvuaz = this.l4m_1;
          this.l4m_1 = _unary__edvuaz + 1 | 0;
          this.k4m_1[_unary__edvuaz] = instance;
        }
      }
      sz() {
        var inductionVariable = 0;
        var last = this.l4m_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.k4m_1[i];
            var instance = !(tmp == null) ? tmp : THROW_CCE();
            this.k4m_1[i] = null;
            this.m4m(instance);
          }
           while (inductionVariable < last);
        this.l4m_1 = 0;
      }
    }
    protoOf($).l6 = close;
    initMetadataForClass($, 'DefaultPool', VOID, VOID, [ObjectPool()]);
    DefaultPoolClass = $;
  }
  return DefaultPoolClass;
}
//region block: exports
export {
  DefaultPool as DefaultPool2gb1fm4epwgu9,
};
//endregion

//# sourceMappingURL=DefaultPool.mjs.map
